// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

// variables
const { GET_PETS, PUT_PET } = ENDPOINTS;

class PetsAPI extends MainAPI {
	/**
	 * @param {*} tableDetails - Contains pagination data
	 */
	async getPets(tableDetails) {
		return API.get(`${GET_PETS}?${queryString.stringify(tableDetails)}`);
	}

	async reactivePet(petId) {
		return API.put(`${PUT_PET}/${petId}/reactivate`);
	}
}

export default new PetsAPI();
